import React, {useState} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import AboutMe from '../components/AboutMe';
import Skills from '../components/Skills';
import Portfolio from '../components/Portfolio';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';


function Home(){
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return(
        <div id="home">
            <header id="header">
                <Sidebar isOpen={isOpen} toggle={toggle}/>
                <Navbar toggle={toggle}/>
            </header>

            <main id="aboutme">
                <Banner/>
                <AboutMe/>
                <Skills/>
                <Portfolio/>
                <ContactForm/>
            </main>
            
            <footer id="footer">
                <Footer />
            </footer>
        </div>
    )
}

export default Home;